/* modules */
import { Component, OnInit, Input } from '@angular/core';

/* services */


/* models */


@Component({
    selector: 'thankYouPage-app',
    template: require('./thankYouPage.component.html')
})

export class ThankYouPageComponent implements OnInit {

    @Input()
    email: string;

    @Input()
    hasAuthorized: boolean;

    @Input() resultInfo: any = [];

    ngOnInit(): void {
        setTimeout(() => {
            if (this.hasAuthorized) {
                window.location.replace('/tv');
            }
        }, 5000);
    }

}



// WEBPACK FOOTER //
// ./src/app/card/components/thankYouPage.component.ts